module.exports = __webpack_public_path__ + "img/패션해체.999d6f18.jpg";